import RelicIcon from './RelicIcon';

const RelicGlyph = ({ relicId }) => (
  <span className="coreboundRelicGlyph">
    <RelicIcon relicId={relicId} />
  </span>
);
export default RelicGlyph;
